module.exports = __webpack_public_path__ + "static/img/ninth_bg2.e68d604e.jpg";